module.exports = "/assets/dist/images/vr_head.png?c96a54cd6912bb71d6760f6b212c83a9";